export const uiConsts = {
  ASIDE_SHOW: '[UI] ASIDE_SHOW',
  DARK_MODE: '[UI] DARK_MODE',
  SIDEBAR_SHOW: '[UI] SIDEBAR_SHOW',
  START_LOADER: '[UI] START_LOADER',
  STOP_LOADER: '[UI] STOP_LOADER',
};
